module.exports = __webpack_public_path__ + "static/media/hammer.f17c63b4.svg";